<template>
    <div class="sdr-box contact-box">
        <h4 style="color: #4f657e;">{{ needhelp[getCurrentLocale] }}</h4>
        <p>{{ sideboxhelptext[getCurrentLocale] }}</p>
        <address class="contact-details">
            <span class="contact-phone"><i class="soap-icon-phone"></i> +49 30 20673716</span>
            <br>
            <a href="mailto:info@kayofly.de" class="contact-email">info@kayofly.de</a>
        </address>
        <br />
        <address class="contact-details">
            <span class="contact-phone"><i class="soap-icon-phone"></i> +49 176 66858855</span>
        </address>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {

        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                needhelp: {
                    en: 'Do you need any help or support?',
                    de: 'Benötigen Sie Hilfe oder Unterstützung?',
                },
                sideboxhelptext: {
                    en: 'We will be happy to help you. Our Contact:',
                    de: 'Wir helfen Ihnen gern weiter. Unser Kontakt:',
                },
                forbeirut: {
                    en: 'For Beirut Flights:',
                    de: 'Für Beirut Flüge:',
                }
                // currentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/shared/sidebar/ContactBox.vue